import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { AppMenuComponent } from '../app-menu/app-menu.component'
import { AppHeaderComponent } from '../app-header/app-header.component'
import { SharedModule } from '../../../../shared/shared.module'
import { AlertMessage, AlertService } from '../../../../shared/alert.service'
import { Observable, Subject, takeUntil } from 'rxjs'
import { CommonModule } from '@angular/common'
import { Store } from '@ngrx/store'
// import { revertSwitchUser } from '../../../../store/auth/auth.actions'
import { selectUser } from '../../../../store/auth/auth.state'

@Component({
  selector: 'app-app-template',
  imports: [RouterOutlet, AppMenuComponent, AppHeaderComponent, SharedModule, CommonModule],
  templateUrl: './app-template.component.html',
  styleUrl: './app-template.component.scss'
})
export class AppTemplateComponent implements OnInit, OnDestroy {
  // alertMessage: string | null = null
  alertMessage: AlertMessage | null = null
  private destroy$ = new Subject<void>()
  isImpersonating = localStorage.getItem('isImpersonating') === 'true'
  user$!: Observable<any>
  constructor(
    private alertService: AlertService,
    private cdr: ChangeDetectorRef,
    private store: Store,
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.user$ = this.store.select(selectUser)
    this.isImpersonating = localStorage.getItem('isImpersonating') === 'true'
    this.alertService.message$.pipe(takeUntil(this.destroy$)).subscribe(msg => {
      // console.log('ALERT RECEIVED:', msg)

      if (!msg) return

      this.alertMessage = msg
      this.cdr.detectChanges()

      // auto hide
      // setTimeout(() => {
      //   this.alertMessage = null
      //   this.cdr.detectChanges()
      // }, 3000)
    })
    // this.alertService.show(
    //   this.alertMessage?.message || 'Something happened',
    //   this.alertMessage?.type
    // )
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  // ngAfterViewInit(): void {
  //   // Thoda delay taaki header fully render ho chuka ho
  //   setTimeout(() => this.setHeaderHeightVar(), 0)
  // }

  // @HostListener('window:resize')
  // onResize() {
  //   this.setHeaderHeightVar()
  // }

  // private setHeaderHeightVar(): void {
  //   const headerEl = this.el.nativeElement.querySelector('.header')
  //   if (headerEl) {
  //     const height = headerEl.offsetHeight
  //     this.renderer.setStyle(document.documentElement, '--header-height', `${height}px`)
  //   }
  // }

  // revert() {
  //   this.store.dispatch(revertSwitchUser())
  // }
}
